import React from "react";
import { Image } from "react-bootstrap";

export default function SiteName() {
  return (
    <p className="text-center fs-25 mb-25">
      <Image src="/mysm_logo_white.png" height="30" />
    </p>
  );
}